import React from "react";
import "./OwSidebar.scss";

type Props = {
    position?: "left" | "right"; // Sidebar position
    children: React.ReactNode; // Content to be rendered inside sidebar
    width?: string; // Optional width control
    isOpen?: boolean; // Optional control for open/close state
    onClose?: () => void; // Optional callback for closing sidebar
};

export const OwSidebar = (props: Props) => {
    return (
        <div className={`OwSidebarWrapper${!props.isOpen ? " closing" : ""}`} onClick={(e) => e.stopPropagation()}>
            <aside
                className={`OwSidebar sidebar ${props.position} ${props.isOpen ? "open" : "closed"}`}
                style={{ width: props.isOpen ? props.width : "0" }}>
                {props.children}
            </aside>
        </div>
    );
};
